export enum BoardRef {
  Starred = 'Starred',
  Recent = 'Recent'
}
